import {
  RECEIVE_CONTACTS,
  RECEIVE_TRADE_DOCUMENT_CONTACTS,
} from "../contactsActionTypes";

const initialState = {
  user_contacts: [],
  trade_document_contacts: [],
};

export default function contacts(state = initialState, action) {
  switch(action.type) {
    case RECEIVE_CONTACTS:
      return {
        ...state,
        user_contacts: action.payload,
      };
    case RECEIVE_TRADE_DOCUMENT_CONTACTS:
      return {
        ...state,
        trade_document_contacts: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/contacts/reducers/contactsReducer.js